import React, { useEffect, useState, useCallback } from "react";
import BasicModal from "../../Components/Modals/BasicModal";
import $ from 'jquery';
import { useNavigate, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import swal from 'sweetalert';
import axios from "axios";
import "../../assets/css/pages/categories.css";
import noImage from "../../assets/media/svg/no-image.svg";

export default function () {
  const navigate = useNavigate();
  const token = useSelector(state => state.token);

  const deleteRow = (table, selector) => {
    table
      .row(selector.parents('tr'))
      .remove()
      .draw(false);
  }

  const toggleActiveStatus = (id) => {
    axios.get('category-is-active-toggle/' + id)
      .then((res) => {
        if (res.status == 200) {
        }
      }).catch(function (error) {
      });
  }

  useEffect(() => {
    $('#categories thead tr')
      .clone(true)
      .addClass('filters display-none')
      .appendTo('#categories thead');

    let table = $('#categories').DataTable({
      "ajax": {
        url: process.env.REACT_APP_API_URL + "all-categories-datatable",
        method: 'GET',
        beforeSend: function (request) {
          request.setRequestHeader("Authorization", 'Bearer ' + token);
        },
        error: function (xhr) {
          if (xhr?.status === 401) {
            axios.defaults.baseURL = process.env.REACT_APP_API_CLEAN_URL;
            axios.post('/logout')
              .then(
                localStorage.removeItem('persist:root'),
                navigate('/login')
              );
          }
        }
      },
      initComplete: function () {
        var api = this.api();

        // For each column
        api
          .columns()
          .eq(0)
          .each(function (colIdx) {
            // Set the header cell to contain the input element
            var cell = $('.filters th').eq(
              $(api.column(colIdx).header()).index()
            );
            var title = $(cell).text();
            $(cell).html('<input type="text" placeholder="' + title + '" />');

            // On every keypress in this input
            $(
              'input',
              $('.filters th').eq($(api.column(colIdx).header()).index())
            )
              .off('keyup change')
              .on('keyup change', function (e) {
                e.stopPropagation();

                // Get the search value
                $(this).attr('title', $(this).val());
                var regexr = '({search})'; //$(this).parents('th').find('select').val();

                var cursorPosition = this.selectionStart;
                // Search the column for that value
                api
                  .column(colIdx)
                  .search(
                    this.value != ''
                      ? regexr.replace('{search}', '(((' + this.value + ')))')
                      : '',
                    this.value != '',
                    this.value == ''
                  )
                  .draw(false);

                $(this)
                  .focus()[0]
                  .setSelectionRange(cursorPosition, cursorPosition);
              });
          });
      },
      "columns": [
        { data: 'id', name: 'id' },
        { data: 'name', name: 'name' },
        { data: 'parents_name', name: 'parents_name' },
        { data: 'code', name: 'code' },
        {
          data: 'category_type',
          orderable: false,
          searchable: false,
          render: function (data, type, row) {
            if (row?.children.length != 0) { //if Has Subcategories
              return `<div class="btn btn-secondary d-block br-0-95-rem py-3 px-4 text-center rounded disabled opacity-100">
                        <div class="mb-1"><i class="fas fa-network-wired fs-1"></i></div>
                        Has Categories
                      </div>`;
            } else { //if Has NOT Subcategories
              if (row?.attributes.length == 0) {
                return `<div class="btn btn-light-primary d-block br-0-95-rem py-3 px-4 text-center rounded disabled opacity-100">
                          <div class="mb-1"><i class="fas fa-list-ul fs-1"></i></div>Attributes : ${row?.attributes.length}
                        </div>`;
              }
              return `<div class="btn btn-light-info d-block br-0-95-rem py-3 px-4 text-center rounded disabled opacity-100">
                        <div class="mb-1"><i class="fas fa-list-ul fs-1"></i></div>Attributes : ${row?.attributes.length}
                      </div>`;
            }
          },
        },
        {
          data: 'products_count',
          name: 'products_count',
          searchable: false,
          orderable: false,
          render: function (data, type, row) {
            return `<p class='text-center'>${row?.products_count}</p>`
          }
        },
        {
          data: 'is_active',
          render: function (data, type, row) {
            let condition = row?.is_active;
            return `<div class="active-notactive">
                      <label class="form-check form-switch form-check-custom form-check-solid">
                        <input class="form-check-input active-block"
                          row-id="${row.id}" row-name="${row.name}"
                          type="checkbox" value="1" ${condition ? "checked='checked'" : ""}>
                        <span class="form-check-label fw-bold text-muted">
                          ${condition ? "Active" : "Blocked"}
                        </span>
                      </label>
                    </div>`;
          },
        },
        {
          data: 'actions',
          orderable: false,
          searchable: false,
          render: function (data, type, row) {
            return `
                    <button type="button"
                        class="btn-primary me-2 mb-2 actions">
                            Actions
                            <i class="fas fa-caret-down"></i>
                    </button>
                    <div class="row-actions display-none hidden-actions">
                        <div class="absolute-div">
                            <button 
                            class="btn btn-primary me-2 mb-4 mt-1 edit"
                            row-id="${row.id}" row-name="${row.name}">
                                <i class="fas fa-edit"></i> Edit
                            </button>

                            ${row.children.length === 0 ? `<button 
                              class="btn btn-primary me-2 mb-4 mt-1 attributes"
                              row-id="${row.id}" row-name="${row.name}">
                                  <i class="fas fa-list"></i> Attributes
                              </button>`: ``}

                            <button 
                            class="btn btn-danger me-2 mb-1 delete"
                            row-id="${row.id}" row-name="${row.name}">
                                <i class="far fa-trash-alt"></i> Delete
                            </button>
                        <div>
                    </div>
                    `;
          },
        }
      ],
      "order": [[0, "desc"]],
    });

    table.on('click', 'button.actions', function () {
      if ($(this).next(".row-actions").hasClass("hidden-actions")) {
        $(this).next(".row-actions").fadeIn(100).removeClass("hidden-actions");
      } else {
        $(this).next(".row-actions").fadeOut(100).addClass("hidden-actions");
      }
    });

    table.on('click', 'button.edit', function () {
      const id = ($(this).attr("row-id"));
      navigate('/categories/' + id + '/edit');
    });

    table.on('click', 'button.attributes', function () {
      const id = ($(this).attr("row-id"));
      navigate('/categories/' + id + '/attributes');
    });

    table.on('click', 'button.delete', function () {
      const id = ($(this).attr("row-id"));
      const name = ($(this).attr("row-name"));
      $(".row-actions").fadeOut(100).addClass("hidden-actions");
      deleteCategory(id, name, table, $(this));
    });

    table.on('click', 'input.active-block', function () {
      const id = ($(this).attr("row-id"));
      const name = ($(this).attr("row-name"));
      if ($(this).is(':checked')) {
        $(this).next(".form-check-label").html("Active");
        $(this).prop('checked', true);
      } else {
        $(this).next(".form-check-label").html("Blocked");
        $(this).prop('checked', false);
      }
      toggleActiveStatus(id);
    });

    $("<span class='table-filter-icon' title='Filter'><i class='fa fa-filter fs-4 br-1000'></i>Filter</span>")
      .insertAfter("#categories_length label");

    $(".table-filter-icon").click(function () {
      $("#categories thead .filters").toggle();

      let condition = $(".table-filter-icon i").hasClass("fa-filter");

      $(".table-filter-icon")
        .html(condition ? "<i class='far fa-times-circle fs-4 br-1000'></i>Close"
          : "<i class='fa fa-filter fs-4 br-1000'></i>Filter");
    });

    let datatableSearch = ".dataTables_wrapper .dataTables_filter input[type=search]";
    $("<i class='fas fa-search'></i>")
      .insertBefore(datatableSearch);
    $(datatableSearch)
      .attr("placeholder", "Search...");
  }, []);

  const addCategory = () => {
    navigate('/categories/create');
  }
  const deleteCategory = (id, name, table, selector) => {
    swal({
      title: "Are you sure?",
      text: 'You want to delete category "' + name + '"?',
      icon: "warning",
      buttons: true,
      dangerMode: true,
      confirm: {
        text: "Yes",
        value: true,
        visible: true,
        className: "",
        closeModal: true
      }
    }).then((result) => {
      console.log(result);
      if (result == true) {
        axios.delete('categories/' + id, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
          }
        }).then(function (res) {
          console.log(res);
          if (res.status == 200 && res.data?.status) {
            swal('The category "' + name + '" has been deleted!', {
              icon: "success",
            });
            deleteRow(table, selector);
            return true;
          } else {
            return false;
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    });
  }

  return (
    <>
      <div>
        <div className="d-block text-right mb-5">
          {true && //Show If user is SuperAdmin
            <>
              <button type="button"
                className="btn btn-light-info mr-3"
                data-bs-toggle="tooltip"
                onClick={() => { navigate('tree') }}
              >
                <i className="fas fa-network-wired fs-3 mr-3"></i> Show Categories Tree
              </button>
              <button type="button"
                className="btn btn-primary"
                data-bs-toggle="tooltip"
                onClick={addCategory}
              >
                <i class="fas fa-plus fs-3 mr-2"></i> Add Category
              </button>
            </>
          }
        </div>
        <table id="categories" className="table align-middle table-row-dashed fs-6 gy-5">
          <thead>
            <tr className="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
              <th>ID</th>
              <th>Name</th>
              <th>Parent Name</th>
              <th>Code</th>
              <th>Attribute Qty</th>
              <th>Products Qty</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody className="text-gray-600 fw-bold"></tbody>
        </table>
      </div>
    </>
  );
}